// src/hooks/useTenantSelectorAccess.ts

import { useMemo } from "react";
import { useAuth } from "../contexts/AuthContext";
import { isTenantSelectorEnabledForUser } from "../utils/tenantSelectorAccess";

/**
 * Hook that determines whether the current user should have access
 * to the tenant selector feature. Combines the master feature flag
 * with per-user email allowlist gating.
 */
export function useTenantSelectorAccess(): boolean {
  const { userInfo } = useAuth();
  const email = userInfo?.email ?? null;

  return useMemo(() => isTenantSelectorEnabledForUser(email), [email]);
}
